import LostPassword from './LostPassword.jsx';
export default LostPassword;